import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useMotiveMobileStyles } from './styles';
import IssueMapper from '../../../../../../helpers/IssueMapper';

const MotiveMobile = ({ ...props }) => {
  const { title, type, motiveId, product } = props;
  const classes = useMotiveMobileStyles();
  const location = useLocation();

  return (
    <Link
      className={classes.link}
      to={{
        search: `?orderId=${product.orderId}&sku=${product.sku}&motiveId=${motiveId}`,
        pathname: IssueMapper.get(motiveId),
        state: { motiveId, type, product, prevRoute: location.pathname },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid #BCBCBC"
      >
        <Typography className={classes.title}>{title}</Typography>
        <IconButton>
          <KeyboardArrowRightIcon />
        </IconButton>
      </Box>
    </Link>
  );
};

MotiveMobile.propTypes = {
  title: PropTypes.string,
  motiveId: PropTypes.string,
  product: PropTypes.object,
  type: PropTypes.string,
};

export default MotiveMobile;
